export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/0c7f90dcab4574f291a5b93f31621815.svg";